import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 md:py-24" data-testid="blog-list">
      <div className="mb-16 max-w-2xl">
        <div className="font-mono-caps text-muted-foreground">Editorial</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-3">Diario olfativo</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">Guías, comparativas y ensayos sobre el arte de la perfumería.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 md:gap-12">
        {posts.map((p, i) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className="group fade-up" style={{ animationDelay: `${i * 80}ms` }} data-testid={`blog-post-${p.slug}`}>
            <div className="aspect-[4/5] overflow-hidden bg-muted mb-4">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="font-mono-caps text-xs text-muted-foreground">{p.category} · {p.date}</div>
            <h2 className="font-serif text-2xl mt-2 leading-tight group-hover:text-navy transition-colors">{p.title}</h2>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{p.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(({ data }) => setPost(data)); }, [slug]);
  if (!post) return <div className="p-24 text-center text-muted-foreground">Cargando…</div>;

  return (
    <article className="max-w-[900px] mx-auto px-6 py-16 md:py-24" data-testid="blog-post">
      <div className="font-mono-caps text-muted-foreground mb-6">{post.category} · {post.date}</div>
      <h1 className="font-serif text-4xl md:text-6xl leading-tight">{post.title}</h1>
      <div className="aspect-[16/9] my-10 overflow-hidden">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
      </div>
      <div className="prose prose-lg max-w-none text-foreground/80 leading-loose whitespace-pre-line">
        {post.body}
      </div>
      <Link to="/blog" className="inline-block mt-12 editorial-link font-mono-caps text-xs">← Volver al editorial</Link>
    </article>
  );
}
